module.exports = "dist/assets/images/2-step.2a95ca184a277ec9541655d0e0554ec0.svg";